function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("line", {
  x1: 4,
  y1: 21,
  x2: 4,
  y2: 14
});

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 4,
  y1: 10,
  x2: 4,
  y2: 3
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 12,
  y1: 21,
  x2: 12,
  y2: 12
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 12,
  y1: 8,
  x2: 12,
  y2: 3
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 20,
  y1: 21,
  x2: 20,
  y2: 16
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 20,
  y1: 12,
  x2: 20,
  y2: 3
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  x1: 1,
  y1: 14,
  x2: 7,
  y2: 14
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  x1: 9,
  y1: 8,
  x2: 15,
  y2: 8
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  x1: 17,
  y1: 16,
  x2: 23,
  y2: 16
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0094dd",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sliders"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/block.dd20bdd6.svg";
export { SvgComponent as ReactComponent };